"use client";

/**
 * CollabV3AppOverlay 컴포넌트
 * @description 스레드 글 · 작품 칸 전체를 덮는 투명 버튼 — 누르면 앱의 그 글 · 작품을 바로 연다(웹에는
 *   글 상세 · 작품 상세가 없다). 감싸는 쪽이 `relative isolate` 여야 한다 — 그래야 이 버튼이 그 안의
 *   그림보다 위에, 하단 고정 바보다는 아래에 선다. 그 안의 바깥 링크는 이 버튼보다 위에 올려(`z-20`)
 *   따로 눌리게 한다 — 버튼 안에 링크를 넣지 않으려는 구조다.
 * @example <CollabV3AppOverlay subject={subject} placement="thread" path={item.appPath} label="Open in app" />
 */
import { memo } from "react";

import type { CollabV3AppOverlayProps } from "./CollabV3Detail.types";
import { useCollabV3OpenApp } from "./useCollabV3OpenApp";

const OVERLAY_CLASS = [
  "absolute inset-0 z-10 cursor-pointer rounded-[var(--fw-radius-md)]",
  "transition-colors hover:bg-[var(--fw-color-surface-neutral-transparent-hovered)]",
  "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--fw-color-border-focused)]",
].join(" ");

const CollabV3AppOverlay = memo<CollabV3AppOverlayProps>(
  ({ subject, placement, path, label }) => {
    const open = useCollabV3OpenApp(subject, placement, path);
    return (
      <button
        type="button"
        aria-label={label}
        onClick={open}
        className={OVERLAY_CLASS}
      />
    );
  },
);

CollabV3AppOverlay.displayName = "CollabV3AppOverlay";

export default CollabV3AppOverlay;
